import Immutable from 'immutable';
import { DEV, PROD, STG } from "./environments";
export default Immutable.Map({
  [DEV]: Immutable.Map({
    indexName: 'marketplace_plugins_dev'
  }),
  [STG]: Immutable.Map({
    indexName: 'marketplace_plugins_stg'
  }),
  [PROD]: Immutable.Map({
    indexName: 'marketplace_plugins_prod'
  })
});